export default __webpack_public_path__ + "static/media/10_sp.4c7f5183.png";